export default __webpack_public_path__ + "static/media/cockoo-clock.9600cd68.mp3";